module.exports = __webpack_public_path__ + "static/media/great-rhino.4465e6d7.gif";